module.exports = "<div class=\"row\">\n    <div class=\"col-lg-12\">\n        <div class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"Search for...\">\n            <span class=\"input-group-btn\">\n        <button class=\"btn btn-default\" type=\"button\">Go!</button>\n      </span>\n        </div><!-- /input-group -->\n    </div><!-- /.col-lg-6 -->\n</div><!-- /.row -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/search/search.component.html
// module id = ./src/app/search/search.component.html
// module chunks = main